<template>
    <div class="customer-list">
        <div class="main-button-bar">
            <el-row class="search-row">
                <el-cascader
                        v-model="params.categoryArr"
                        clearable
                        collapse-tags
                        :show-all-levels="false"
                        placeholder="产品类型"
                        class="search-item"
                        :options="categorys"
                        :props="categoryprops"
                ></el-cascader>

                <el-cascader
                        v-model="params.countryArr"
                        clearable
                        collapse-tags
                        :show-all-levels="false"
                        placeholder="所属国家"
                        class="search-item"
                        :options="$tools.countrys"
                        :props="countryprops"
                ></el-cascader>

                <el-select
                    v-model="params.fromType"
                    clearable
                    collapse-tags
                    placeholder="来源"
                    class="search-item"
                >
                    <el-option v-for="item in fromTypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>

                <el-select
                    v-model="params.level"
                    clearable
                    placeholder="客户等级"
                    class="search-item"
                >
                    <el-option v-for="item in levelData" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>

                <el-input clearable v-model="params.remark" placeholder="背调详情" class="search-item"></el-input>

                <el-dropdown class="add-button" size="medium"  @command="handleMore">
                    <el-button type="success" size="medium">更多操作<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="copyAll">批量复制邮箱</el-dropdown-item>
                        <el-dropdown-item v-if="pageType != 2" command="addcustomer">新增客户</el-dropdown-item>
                        <el-dropdown-item v-if="pageType == 3" command="setMarketing">一键填写营销记录</el-dropdown-item>
                        <el-dropdown-item v-if="pageType == 1" command="releaseAll">一键释放客户</el-dropdown-item>
                        <el-dropdown-item v-if="pageType == 3" command="handover">一键交接客户</el-dropdown-item>
                        <el-dropdown-item v-if="pageType == 3" command="exportCustomer">导出客户信息</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

            </el-row>
            <el-row class="search-row">
 
                <el-input clearable v-model="params.companyName" placeholder="公司名称" class="search-item"></el-input>
                <el-input clearable v-model="params.name" placeholder="客户名称" class="search-item"></el-input>
                <el-input clearable v-model="params.position" placeholder="客户职位" class="search-item"></el-input>
                <el-input clearable v-model="params.mail" placeholder="联系邮箱" class="search-item"></el-input>
                <el-input clearable v-model="params.phone" placeholder="客户电话" class="search-item"></el-input>
                <el-input clearable v-model="params.address" placeholder="联系地址" class="search-item"></el-input>

  

                <el-select
                    v-if="pageType == 1"
                    v-model="params.statusArr"
                    clearable
                    collapse-tags
                    placeholder="客户状态"
                    multiple=true
                    class="search-item"
                >
                    <el-option v-for="item in status" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>

                
                <!-- <el-button v-if="pageType == 1" type="danger" size="small" style="float:right;" @click="releaseAll">一键释放</el-button>
                
                <el-button v-if="pageType == 3" type="danger" size="small" style="float:right;" @click="handover">一键交接</el-button> -->
            </el-row>
            <el-row class="search-row">
                <sn-user-search-input
                        title="录入业务"
                        class="search-item"
                        @change="
                (a) => {
                    params.creator = a;
                }
                "
                    ></sn-user-search-input>

                <el-date-picker
                    type="date"
                    placeholder="录入时间（开始）"
                    v-model="params.createTimeStart"
                    style="width:180px"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>
                <el-date-picker
                    type="date"
                    placeholder="录入时间（截止）"
                    v-model="params.createTimeEnd"
                    style="width:180px"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>

                <sn-user-search-input
                    v-if="pageType!=3"
                        title="所属业务"
                        class="search-item"
                        @change="
                (a) => {
                    params.belongId = a;
                }
                "
                    ></sn-user-search-input>
                
                <el-select
                    v-if="pageType == 1"
                    v-model="params.hasRelease"
                    clearable
                    placeholder="是否被释放"
                    class="search-item"
                >
                    <el-option v-for="item in Yndata" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>

                <el-button type="primary" size="small" @click="page(1)">搜索</el-button>
            </el-row>
        </div>

        <el-table
            :data="records"
            stripe
            style="width: 100%"
            :height="this.$tools.mainHeight() - 180"
            class="customer-list-table"
            @sort-change="sortChange"
        >
        <el-table-column prop="categoryName" label="开发产品" width="200"></el-table-column>

        <el-table-column prop="country" label="所属国家" width="100">
            <template slot-scope="rdata">{{ $tools.countryName(rdata.row.country)}}</template>
        </el-table-column>


        <el-table-column prop="fromType" label="来源" width="100">
            <template slot-scope="rdata">{{ converFromType(rdata.row.fromType)}}</template>
        </el-table-column>
        <el-table-column prop="level" label="等级" width="60"></el-table-column>


        <el-table-column prop="companyName" label="公司名称" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="name" label="客户名称" width="300" show-overflow-tooltip>
            <template slot-scope="rdata">
                <el-tag class="attr-tag" :key="tag" v-for="tag in formatStrint2Arr(rdata.row.name)">{{tag}}</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="status" label="客户状态" width="150">
            <template slot-scope="rdata">
                <el-tag v-if="rdata.row.status == 10" type="info">无回复</el-tag>
                <el-tag v-else-if="rdata.row.status == 20">一次回复</el-tag>
                <el-tag v-else-if="rdata.row.status == 30" type="success">多次回复-意向高</el-tag>
                <el-tag v-else-if="rdata.row.status == 40" type="danger">多次回复-意向低</el-tag>
                <el-tag v-else-if="rdata.row.status == 60" type="success">成交样板</el-tag>
                <el-tag v-else-if="rdata.row.status == 70" type="success">成交大货</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="position" label="客户职位" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="mail" label="联系邮箱" width="400" show-overflow-tooltip>
            <template slot-scope="rdata">
                <el-tag class="attr-tag" :key="tag" v-for="tag in formatStrint2Arr(rdata.row.mail)">{{tag}}</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="phone" label="联系电话" width="200" show-overflow-tooltip>

        </el-table-column>
        <el-table-column prop="address" label="联系地址" width="300" show-overflow-tooltip>

        </el-table-column>
        <el-table-column prop="remark" label="背调详情" width="300" show-overflow-tooltip>
            <template slot-scope="rdata">
                {{ rdata.row.remark}}
            </template>
        </el-table-column>

        <el-table-column prop="belongName" label="所属业务" width="100"></el-table-column>
        <el-table-column prop="selectTime" label="选入时间" width="160">
            <template slot-scope="rdata">{{ $tools.timestampToTime(rdata.row.selectTime)}}</template>
        </el-table-column>
        <el-table-column prop="creatorName" label="录入业务" width="100"></el-table-column>
        <el-table-column prop="shopName" label="录入时间" width="160">
            <template slot-scope="rdata">{{ $tools.timestampToTime(rdata.row.createTime)}}</template>
        </el-table-column>
        <el-table-column prop="shopName" label="上次营销时间" width="160">
            <template slot-scope="rdata">{{ $tools.timestampToTime(rdata.row.lastTime)}}</template>
        </el-table-column>
        <el-table-column prop="times" label="营销次数" width="100"></el-table-column>
       
        <el-table-column label="操作" :width="pageType==2 ? 120 : 300" fixed="right">
                <template slot-scope="rdata">
                    <el-button type="text" size="small" v-if="pageType==1 || pageType==3" @click="copy(rdata.row.mail)">复制邮箱</el-button>

                    <el-button type="text" size="small" @click="info(rdata.row.id, false)">详情</el-button>
                    <el-button type="text" size="small" v-if="pageType==3" @click="marketingInfo(rdata.row.id)">营销</el-button>
                    <el-button type="text" size="small" v-if="pageType==3" @click="info(rdata.row.id, true)">修改</el-button>
                    <el-button type="text" size="small" v-if="pageType==2" @click="select(rdata.row.id)">选入</el-button>
                    
                    <el-button type="text" size="small" v-if="pageType==3" @click="release(rdata.row.id)">释放</el-button>
                    <el-button type="text" size="small" v-if="pageType==1" @click="clearBelong(rdata.row.id)">释放</el-button>
                    <el-button type="text" size="small" v-if="pageType==1" @click="dispense(rdata.row.id)">分配业务</el-button>
                    <el-button type="text" size="small" v-if="pageType==1" @click="info(rdata.row.id, true)">修改</el-button>


                    <el-button type="text" size="small" v-if="pageType==1 || pageType==3"  @click="deleteById(rdata.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            small
            layout="total, prev, pager, next"
            :total="params.total"
            :page-size="params.size"
            :current-page.sync="params.current"
            @current-change="page"
        ></el-pagination>

        <el-dialog title="分配业务员" width="400px" :visible.sync="dispenseDialogShow" @closed="dispenseDialogShow = false" class="dispense-dialog">
            <sn-user-search-input ref="disuser" title="分配业务员" class="search-item" @change="(a) => { dispenseId = a; }"></sn-user-search-input>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" class="op-button" @click="doDispense">确认</el-button>
            </div>
        </el-dialog>

        <el-dialog :title="marketingDialogBatch ? '批量营销记录填写' : '填写营销记录'" width="800px" :visible.sync="marketingDialogShow" @closed="marketingDialogShow = false" class="marketing-dialog">
            <el-form>
                <el-form-item label="客户状态">
                    <el-select
                        v-model="marketing.status"
                        clearable
                        placeholder="选择状态"
                        class="search-item"
                    >

                        <el-option v-for="item in status" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="回访/开发/营销记录">
                    <el-input type="textarea" :rows="10" placeholder="请输入内容" v-model="marketing.remark"></el-input>
                </el-form-item>
            </el-form>       
            <div slot="footer" class="dialog-footer">
                <el-button v-if="!marketingDialogBatch" type="primary" size="small" class="op-button" @click="savemarketings">保存</el-button>
                <el-button v-else type="primary" size="small" class="op-button" @click="batchSaveMarketings">批量填写</el-button>
            </div>
        </el-dialog>

        <el-dialog title="一键交接" width="400px" :visible.sync="handoverDialog" @closed="handoverDialog = false" class="handover-dialog">
            <sn-user-search-input ref="disuser" title="交接对象" class="search-item" @change="(a) => { dispenseId = a; }"></sn-user-search-input>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" class="op-button" @click="doHandover">确认交接</el-button>
            </div>
        </el-dialog>

        <el-dialog title="一键释放" width="600px" :visible.sync="releaseDialog" @closed="releaseDialog = false" class="release-dialog">
            <el-alert title="-1或者不填为不进行释放" type="error" :closable="false" style="margin-bottom: 10px;"></el-alert>

            <el-form label-width="200px">
                <el-form-item label="无回复释放时间">
                    <el-input-number v-model="releaseData.none" controls-position="right" :controls=false :min="-1" :max="999" :precision="0"></el-input-number>
                </el-form-item>
                <el-form-item label="一次回复释放时间">
                    <el-input-number v-model="releaseData.one" controls-position="right" :controls=false :min="-1" :max="999" :precision="0"></el-input-number>
                </el-form-item>
                <el-form-item label="多次回复-意向高释放时间">
                    <el-input-number v-model="releaseData.mt" controls-position="right" :controls=false :min="-1" :max="999" :precision="0"></el-input-number>
                </el-form-item>
                <el-form-item label="多次回复-意向低释放时间">
                    <el-input-number v-model="releaseData.ml" controls-position="right" :controls=false :min="-1" :max="999" :precision="0"></el-input-number>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" class="op-button" @click="doReleaseAll">确认释放</el-button>
            </div>
        </el-dialog>

        <el-drawer
        :title="'客户名称【 ' + customer.name + ' 】详情'"
        :visible.sync="infoDialogShow"
        direction="btt"
        :before-close="handleClose"
        :destroy-on-close="true"
        :size="this.$tools.mainHeight() + 'px'"
        >
            <div class="info-tab-outer">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="基本信息" name="baseinfo" v-if="pageType != 2">
                        <el-button
                            v-if="infoEdit"
                            type="primary"
                            size="small"
                            class="op-button"
                            style="float: right;"
                            @click="dosave"
                        >保存</el-button>
                        <el-form :model="customer" class="customer-form">
                            <el-form-item label="来源">
                                <el-cascader
                                    v-model="customer.fromType"
                                    clearable
                                    placeholder="选择类型"
                                    class="search-item"
                                    :options="fromTypes"
                                    :props="categoryprops2"
                                    style="width: 100%"
                                    :disabled="!infoEdit"
                                ></el-cascader>
                            </el-form-item>

                            <el-form-item label="开发产品">
                                <el-cascader
                                    v-model="customer.categoryId"
                                    clearable
                                    placeholder="选择类型"
                                    class="search-item"
                                    :options="categorys"
                                    :props="categoryprops2"
                                    style="width: 100%"
                                    :disabled="!infoEdit"
                                ></el-cascader>
                            </el-form-item>

                            <el-form-item label="所属国家">
                                <el-cascader
                                    v-model="customer.country"
                                    clearable
                                    placeholder="选择国家"
                                    class="search-item"
                                    :options="$tools.countrys"
                                    :props="countryprops2"
                                    style="width: 100%"
                                    :disabled="!infoEdit"
                                ></el-cascader>
                            </el-form-item>

                            <el-form-item label="录入时间">
                                {{ $tools.timestampToTime(customer.createTime)}}
                            </el-form-item>

                            <el-form-item label="选入时间">
                                {{ $tools.timestampToTime(customer.selectTime)}}
                            </el-form-item>

                            <el-form-item label="最近营销时间">
                                {{ $tools.timestampToTime(customer.lastTime)}}
                            </el-form-item>

                            <el-form-item label="客户等级">
                                <el-select
                                    v-model="customer.level"
                                    clearable
                                    placeholder="客户等级"
                                    class="search-item"
                                    :disabled="!infoEdit"
                                >
                                    <el-option v-for="item in levelData" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="公司名称">
                                <el-input v-model="customer.companyName" :disabled="!infoEdit"></el-input>
                            </el-form-item>

                            <el-form-item label="客户名称">
                                <span v-if="infoEdit">
                                    <el-tag class="attr-tag" :key="tag" v-for="tag in formatStrint2Arr(customer.name)" closable :disable-transitions="false" @close="removeVal(customer, 'name', tag)">{{tag}}</el-tag>
                                    <el-input v-if="nameVisible" class="input-new-tag attr-tag" v-model="nameValue" ref="nameTagInput" size="small" @keyup.enter.native="handleNameInputConfirm(customer)" @blur="handleNameInputConfirm(customer)"></el-input>
                                    <el-button v-else class="button-new-tag attr-tag" size="small" @click="showNameInput">添加名称</el-button>
                                </span>
                                <span v-else>
                                    <el-tag class="attr-tag" :key="tag" v-for="tag in formatStrint2Arr(customer.name)">{{tag}}</el-tag>
                                </span>
                            </el-form-item>

                            <el-form-item label="联系邮箱">
                                <span v-if="infoEdit">
                                    <el-tag class="attr-tag" :key="tag" v-for="tag in formatStrint2Arr(customer.mail)" closable :disable-transitions="false" @close="removeVal(customer, 'mail', tag)">{{tag}}</el-tag>
                                    <el-input v-if="mailVisible" class="input-new-tag attr-tag" v-model="mailValue" ref="mailTagInput" size="small" @keyup.enter.native="handleMailInputConfirm(customer)" @blur="handleMailInputConfirm(customer)"></el-input>
                                    <el-button v-else class="button-new-tag attr-tag" size="small" @click="showMailInput">添加邮箱</el-button>
                                </span>
                                <span v-else>
                                    <el-tag class="attr-tag" :key="tag" v-for="tag in formatStrint2Arr(customer.mail)">{{tag}}</el-tag>
                                </span>
                            </el-form-item>

                            <el-form-item label="客户状态">
                                <el-select
                                    v-model="customer.status"
                                    clearable
                                    placeholder="客户状态"
                                    class="search-item"
                                    :disabled="!infoEdit || pageType!=1"
                                >
                                    <el-option v-for="item in status" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="客户职位">
                                <el-input v-model="customer.position" :disabled="!infoEdit"></el-input>
                            </el-form-item>

                            <el-form-item label="联系电话">
                                <el-input v-model="customer.phone" :disabled="!infoEdit"></el-input>
                            </el-form-item>
                            <el-form-item label="联系地址">
                                <el-input v-model="customer.address" :disabled="!infoEdit"></el-input>
                            </el-form-item>
                            <el-form-item label="背调详情">
                                <el-input type="textarea" v-model="customer.remark" :rows="5" :disabled="!infoEdit"></el-input>
                            </el-form-item>
                            <el-form-item label="营销次数">
                                {{ customer.times }}
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="开发记录" name="exploitinfo">
                        <el-timeline :reverse="reverse" :style="'height:' + (this.$tools.mainHeight() - 135) + 'px;overflow:auto;'" >
                            <el-timeline-item v-for="(activity, index) in marketings" :key="index" :timestamp="activity.creatorName + ' 于 ' + $tools.timestampToTime(activity.createTime)" placement="top">
                                客户状态: {{ getStatusName(getmarketingVal(activity.fieldVal, "status")) }} <br>
                                开发内容: {{ getmarketingVal(activity.fieldVal, "remark") }}
                            </el-timeline-item>
                        </el-timeline>
                    </el-tab-pane>
                    <el-tab-pane label="变更记录" name="changeinfo">
                        <el-timeline :reverse="reverse" :style="'height:' + (this.$tools.mainHeight() - 135) + 'px;overflow:auto;'" >
                            <el-timeline-item v-for="(activity, index) in changes" :key="index" :timestamp="activity.creatorName + ' 于 ' + $tools.timestampToTime(activity.createTime) + ' 修改 ' + getFieldName(activity.fieldName) + ' 原内容如下'" placement="top">
                               {{ tranchangeval(activity.fieldName, activity.fieldVal) }}
                            </el-timeline-item>
                        </el-timeline>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-drawer>
    </div>
</template>

<style lang="scss">
    .info-tab-outer {
        margin: 5px 10px;
    }
    .info-div {
        overflow: hidden;
    }

    .customer-form {
    width: 1000px;

    .el-form-item {
        float: left;

        .el-form-item__label {
            width: 100px;
        }

        .el-form-item__content {
            width: 400px;
            float: left;
        }
    }
}

.main-button-bar {
    .search-item {
        width: 180px!important;
    }
}

.attr-tag {
    margin-right: 10px;
}
</style>

<script>
import SnUserSearchInput from "../components/SnUserSearchInput.vue";
import VueClipboard from 'vue-clipboard2'
export default {
    components: { SnUserSearchInput},
    props: {
        pageUrl: { type: String, default: false },
        pageType:  { type: Number, default: false }, // 1 管理 2 公海 3个人
    },
    data() {
        return {
            records: [],
            categorys: [],            
            countrys: [],
            changes: [],
            marketings:[],
            status: [{id:"10", name:"无回复"}, {id:"20", name:"一次回复"}, {id:"30", name:"多次回复-意向高"}, {id:"40", name:"多次回复-意向低"}, {id:"60", name:"成交样板"}, {id:"70", name:"成交大货"}],
            levelData: [{id:"A", name:"A"}, {id:"B", name:"B"}, {id:"C", name:"C"}, {id:"D", name:"D"}],
            fromTypes:[{id:"A", name:"阿里"} ,{id:"C", name:"自主"}, {id:"S", name:"公司提供"}],
            statusCache: null,
            params: {
                size: 50,
                categoryArr:[],
                countryArr:[],
                statusArr:[],
            },
            countryprops: {
                value: "id",
                label: "name",
                expandTrigger: "hover",
                emitPath: false,
                multiple: true,
            },

            countryprops2: {
                value: "id",
                label: "name",
                expandTrigger: "hover",
                emitPath: false,
            },
            categoryprops: {
                value: "id",
                label: "name",
                expandTrigger: "hover",
                emitPath: false,
                multiple: true,
            },
            categoryprops2: {
                value: "id",
                label: "name",
                expandTrigger: "hover",
                emitPath: false,
            },
            Yndata: [{id: "Y", name: "是"}, {id: "N", name: "否"}]
            ,dispenseDialogShow: false
            ,dispenseId: null
            ,id: null
            ,marketingDialogShow: false
            ,marketingDialogBatch: false
            ,infoDialogShow: false
            ,infoEdit: false
            ,handoverDialog: false
            ,releaseDialog: false
            ,customer: {}
            ,activeName: "baseinfo"
            ,marketing: {}
            ,categorysCache: {}
            ,releaseData: {none: 60, one: 30, ml: -1, mt: -1}
            ,nameVisible: false
            ,nameValue: null
            ,mailVisible: false
            ,mailValue: null
            ,nameSplit: "#%#"
        }
    },
    methods: {
        search(){
            this.customers = []
            this.pageList()
        },

        page(current) {
            let _this = this;

            if (current) {
                _this.params.current = current;
            }

            _this.params.country = _this.params.countryArr.join(",");
            _this.params.category = _this.params.categoryArr.join(",");
            _this.params.status = _this.params.statusArr.join(",");
            
            _this.$http.post(
                [_this.pageUrl ? _this.pageUrl : "customer/mypage", _this.params],
                [
                    function (data) {
                        _this.params.total = data.total;
                        _this.records = data.records
                    },
                ],
                ".alibaba-buyer-table"
            );
        },

        clearBelong(id) {
            let _this = this;

            _this.$tConfirm.show("确认清空归属业务员？(客户立即被释放到公海)", function (val) {
                _this.$http.post(
                    ["customer/clearBelong", {id: id}],
                    [
                        function (data) {
                            _this.page();
                        },
                    ],
                    ".customer-list"
                );
            })
        },

        release(id) {
            let _this = this;

            _this.$tConfirm.show("确认清空归属业务员？(客户立即被释放到公海)", function (val) {
                _this.$http.post(
                    ["customer/release", {id: id}],
                    [
                        function (data) {
                            _this.page();
                        },
                    ],
                    ".customer-list"
                );
            })
        },

        select(id) {
            let _this = this;

            _this.$tConfirm.show("确认选入客户，会扣除每月营销额度？（后续去我的客户中营销）", function (val) {
                _this.$http.post(
                    ["customer/select", {id: id}],
                    [
                        function (data) {
                            _this.page();
                        },
                    ],
                    ".customer-list"
                );
            })
        },

        dispense(id) {
            let _this = this;

            _this.id = id;
            _this.dispenseId = null;
            _this.dispenseDialogShow = true;
        },

        doDispense() {
            let _this = this;

            _this.$http.post(
                ["customer/dispense", {id: _this.id, belongId: _this.dispenseId}],
                [
                    function (data) {
                        _this.$refs["disuser"].clear();
                        _this.dispenseDialogShow = false;
                        _this.page();
                    },
                ],
                ".customer-list"
            );
        },

        addcustomer() {
            let _this = this;
            _this.customer = {}
            _this.infoEdit = true;
            _this.activeName = "baseinfo";
            _this.infoDialogShow = true;
        },

        info(id, edit) {
            let _this = this;
            let url = "customer/myinfo";
            
            _this.id = id;

            if ( _this.pageType == 1) {
                url = "customer/info";
            } else if ( _this.pageType == 2) {
                url = "customer/publicinfo";
            }

            _this.$http.post(
                [url, {id: id}],
                [
                    function (data) {
                        _this.customer = data;
                        _this.customer.name = _this.customer.name ? _this.customer.name.split(_this.nameSplit) : []
                        _this.customer.mail = _this.customer.mail ? _this.customer.mail.split(_this.nameSplit) : []
                        _this.infoEdit = edit;
                        _this.activeName = "baseinfo";
                        _this.infoDialogShow = true;
                    },
                ],
                ".customer-list"
            ); 
        },

        dosave() {
            let _this = this;
            let url = _this.pageType == 1 ? "customer/saveorupdate" : "customer/createoredit";

            if (_this.customer.name) {
                _this.customer.name = _this.customer.name.join(_this.nameSplit)
            }

            if (_this.customer.mail) {
                _this.customer.mail = _this.customer.mail.join(_this.nameSplit)
            }

            _this.$http.post(
                [url, _this.customer],
                [
                    function (data) {
                        _this.page(1)
                        _this.infoDialogShow = false;
                    },
                    function() {
                        _this.infoDialogShow = false;
                    }
                ],
                ".customer-list"
            ); 
        },

        getChange(type) {
            let _this = this;
            let url = "customer/change/getInfo"

            if (_this.pageType == 1) {
                url = "customer/change/getmanageInfo"
            } else if (_this.pageType == 2) {
                url = "customer/change/getpublicInfo"
            }

            _this.$http.post(
                [url, {customerId: _this.id, changeType : type}],
                [
                    function (data) {
                        if (type == "INFO") {
                            _this.changes = data
                        } else {
                            _this.marketings = data
                        }
                    },
                ],
                ".customer-list"
            );
        },

        handleClick(tab,b) {
            if (tab.paneName == "changeinfo") {
                this.getChange("INFO");
            } else if (tab.paneName == "exploitinfo") {
                this.getChange("MARKETING");
            }
        },

        getCategory() {
            let _this = this;

            _this.$http.post(
                ["alibaba/product/category/tree"],
                [
                    function (data) {
                        _this.categorys = data;
                        _this.initCategorysCache();
                        
                    },
                ],
                ".customer-list"
            );
        }

        ,initCategorysCache() {
            let data = {}

            for (var i in this.categorys) {
                data[this.categorys[i].id] = this.categorys[i].name

                if (this.categorys[i].children) {
                    this.initCategorysChilrenCache(this.categorys[i].children, data)
                }
            }

            this.categorysCache = data
        }

        ,initCategorysChilrenCache(children, data) {
            for (var i in children) {
                data[children[i].id] = children[i].name

                if (children[i].children) {
                    this.initCategorysChilrenCache(children[i].children, data)
                }
            }
        }

        ,getFieldName(key) {
            let cache = {NAME: "客户名称", POSITION: "客户职位", MAIL: "联系邮箱", PHONE: "联系电话", ADDRESS: "联系地址", REMARK: "背调详情", COUNTRY: "所属国家", CATEGORY_ID: "开发产品", BELONG_ID: "所属业务", STATUS: "客户状态", LEVEL: "客户等级", FROM_TYPE: "来源"}
            return cache[key]
        }

        ,marketingInfo(id) {
            let _this = this;
            _this.id = id;
            
            _this.$http.post(
                ["customer/myinfo", {id: id}],
                [
                    function (data) {
                        _this.marketing = {status: data.status};
                        _this.marketingDialogBatch = false;
                        _this.marketingDialogShow = true;
                    },
                ],
                ".customer-list"
            ); 
        }

        ,savemarketings() {
            let _this = this;

            _this.$http.post(
                ["customer/change/save", {customerId: _this.id, fieldVal: _this.marketing, fieldName: "MARKETING"}],
                [
                    function (data) {
                        _this.page();
                        _this.marketingDialogShow = false;
                    },
                ],
                ".customer-list"
            );
        }
        ,tranchangeval(fieldName, fieldVal) {
            if (fieldName == "COUNTRY") {
                return this.$tools.countryName(fieldVal);
            } else if (fieldName == "CATEGORY_ID") {
                return this.categorysCache[fieldVal];
            } else if (fieldName == "STATUS") {
                return this.getStatusName(fieldVal)
            } else if (fieldName == "FROM_TYPE") {
                return this.converFromType(fieldVal)
            } else {
                return fieldVal ? fieldVal : "";
            }
        }

        ,getStatusName(id) {
            let _this = this

            if (_this.statusCache == null) {
                _this.statusCache = {}

                for (var i in _this.status) {
                    _this.statusCache[_this.status[i].id] = _this.status[i].name
                }
            }

            return _this.statusCache[id]
        }
        ,releaseAll() {
            let _this = this;

            _this.$tConfirm.show("此动作会批量释放符合规则的数据至公海，请确认是否操作？", function (val) {
                _this.releaseDialog = true;
                
            })
        }
        ,doReleaseAll() {
            let _this = this;

            _this.$tConfirm.show("确认进行一键释放？", function (val) {
                _this.$http.post(
                    ["customer/releaseAll", _this.releaseData],
                    [
                        function (data) {
                            _this.page();
                            _this.releaseDialog = false;
                        },
                    ],
                    ".customer-list"
                );
            })
        }
        ,handover() {
            let _this = this;

            _this.$tConfirm.show("此动作会批量将所有资源移交给指定对象！！！", function (val) {
                _this.dispenseId = null;
                _this.handoverDialog = true
            })
        }
        ,doHandover() {
            let _this = this;

            _this.$tConfirm.show("确认交接？", function (val) {
                _this.$http.post(
                    ["customer/handover", {belongId: _this.dispenseId}],
                    [
                        function (data) {
                            _this.page();
                            _this.handoverDialog = false;
                        },
                    ],
                    ".customer-list"
                );
            })
        }
        ,getmarketingVal(val, key) {
            try {
                return JSON.parse(val)[key]
            } catch{}
        }
        ,formatStrint2Arr(data) {
            if (!data) {
                return []
            } else if (typeof data == "string") {
                return data.split(this.nameSplit)
            } else {
                return data
            }
        }
        ,removeVal(data, attrName, removeData) {
            let temp = this.formatStrint2Arr(data[attrName])

            for (var i in temp) {
                if (temp[i] == removeData) {
                    temp.splice(i, 1);
                    break;
                }
            }

            data[attrName] = temp
        }
        ,showNameInput() {
            this.nameVisible = true;
            this.$nextTick(_ => {
                this.$refs.nameTagInput.$refs.input.focus();
            });
        }
        ,handleNameInputConfirm(data) {
            if (this.nameValue) {
                let temp = this.formatStrint2Arr(data.name);
                temp.push(this.nameValue);
                data.name = temp;
            }

            this.nameVisible = false;
            this.nameValue = null;
        }
        ,showMailInput() {
            this.mailVisible = true;
            this.$nextTick(_ => {
                this.$refs.mailTagInput.$refs.input.focus();
            });
        }
        ,handleMailInputConfirm(data) {
            if (this.mailValue) {
                let temp = this.formatStrint2Arr(data.mail);
                temp.push(this.mailValue);
                data.mail = temp;
            }

            this.mailVisible = false;
            this.mailValue = null;
        }
        ,deleteById(id) {
            let _this = this;
            let url = "";
            let msg = "";
            _this.id = id;

            if ( _this.pageType == 3) {
                url = "customer/removeMyself";
                msg = "是否确认删除录入人为自己的数据?(录入人不是自己则删除无效,可联系业务经理进行删除)"
            } else if ( _this.pageType == 1) {
                url = "customer/removeById";
                msg = "是否确认删除数据?"
            }

            
            _this.$tConfirm.show(msg, function (val) {
                _this.$http.post(
                    [url, {id: id}],
                    [
                        function (data) {
                            _this.page();
                        },
                    ],
                    ".customer-list"
                ); 
            })
        }
        ,copy(mail, message) {
            let _this = this;

            if (mail) {
                _this.$copyText(mail.split(_this.nameSplit).join(";")).then(function (e) {
                    _this.$message({message: message ? message : "拷贝成功" , type: "success"});
                }, function (e) {
                    _this.$message({message: "拷贝失败", type: "error"});
                })
            } else {
                _this.$message({message: "拷贝失败", type: "error"});
            }
        }
        ,copyAll() {
            let _this = this;
            let mails = [];

            for (var i in _this.records) {
                var m = _this.records[i].mail;

                if (m) {
                    mails.push(m);
                }
            }

            _this.params.pageType = _this.pageType;
            _this.$http.post( ["customer/updateTimes", _this.params],
                    [
                        function (data) {
                            _this.copy(mails.join(_this.nameSplit), "拷贝当前页面所有客户邮箱成功");
                        },
                    ],
                    ".alibaba-buyer-table"
                );
        }
        ,setMarketing() {
            let _this = this;
            _this.marketing = {status : "10", remark: "邮件批量营销"}
            //_this.marketing.status = "10"
            //_this.marketing.remark = "邮件批量营销"
            _this.marketingDialogBatch = true;
            _this.marketingDialogShow = true
        }

        ,batchSaveMarketings() {
            let _this = this;

            _this.$tConfirm.show("是否一键填写营销记录到当前页面所有客户中？", function (val) {
                _this.params.marketing = _this.marketing.remark;
                _this.params.marketingStatus = _this.marketing.status;

                _this.$http.post( ["customer/autoMarketing", _this.params],
                    [
                        function (data) {
                            _this.marketingDialogShow = false;
                            _this.params.total = data.total;
                            _this.records = data.records
                        },
                    ],
                    ".alibaba-buyer-table"
                );
            })
        }
        ,handleMore(command) {
            eval("this." + command + "()")
        }
        ,converFromType(type) {
            let types = {"S" : "公司提供", "C" : "自主", "A" : "阿里"};
            return types[type] ? types[type] : "";
        }
        ,exportCustomer() {
            
        }
    },
    mounted() {
        this.getCategory()
        this.page();
    },

}
</script>